import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomChip from "./CustomChip";
import { ExpandMoreRounded, HighlightOffRounded } from "@material-ui/icons";

const SearchTerms = (props) => {

    const { t } = useTranslation();

    return (
        <>
            <Autocomplete
                options={props.searchTerms}
                freeSolo
                multiple
                size="small"
                limitTags={5}
                onChange={(event, value) => {
                    props.setSearchTerms(value);
                }}
                style={{borderRadius: '10px'}}
                renderTags={(value, props) =>
                    value.map((option, index) => (
                        <CustomChip
                            id={index} key={index}
                            className="chip bg-dark-gray"
                            size="small"
                            color="#575760"
                            deleteIcon={
                                <HighlightOffRounded />
                            }
                            label={option} {...props({ index })}
                        />
                    ))
                }
                renderInput={(params) =>
                    <TextField
                        sx={{
                            "& .MuiOutlinedInput-root": {
                            borderRadius: "10px"
                            }
                        }}
                        size="small"
                        style={{ width: '500px' }}
                        label={t('searchTerms')} {...params} />
                }
                popupIcon={<ExpandMoreRounded />}
            />
        </>
    );
}

SearchTerms.propTypes = {
    searchTerms: PropTypes.array,
    setSearchTerms: PropTypes.func
};

export default SearchTerms;
